import React from "react";
import CheckoutCard from "../components/CheckoutCard";
import { useCheckoutSession } from "../hooks/useCheckoutSession";
import { buildEstiaPaymentDeepLink } from "../services/paymentLinks";
import { isEmbeddedCheckout } from "../utils/embedMode";

const shellClassName = isEmbeddedCheckout() ? "ep-shell ep-shell--embed" : "ep-shell";

const CheckoutPage: React.FC = () => {
  const {
    loading,
    error,
    sessionData,
    viewState,
    timeRemaining,
    qrDataUrl,
    close,
    refreshQr,
  } = useCheckoutSession();

  const formatTime = (seconds: number): string => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins.toString().padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
  };

  const formatCurrency = (amount: number, currency: string): string => {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: currency,
    }).format(amount);
  };

  if (loading) {
    return (
      <div className={shellClassName}>
        <div className="ep-loadingCard">
          <div className="ep-spinner"></div>
          <p>Loading secure checkout...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className={shellClassName}>
        <div className="ep-loadingCard ep-loadingCard--error">
          <p>{error}</p>
        </div>
      </div>
    );
  }

  if (!sessionData) {
    return null;
  }

  return (
    <div className={shellClassName}>
      <div className="ep-modalWrap">
        <CheckoutCard
          state={viewState}
          amountLabel={formatCurrency(sessionData.amount, sessionData.currency)}
          timeLabel={formatTime(timeRemaining)}
          qrDataUrl={qrDataUrl}
          appLaunchUrl={buildEstiaPaymentDeepLink(sessionData.sessionId)}
          onClose={close}
          onRefreshQr={refreshQr}
        />
      </div>
    </div>
  );
};

export default CheckoutPage;
